export default "__VITE_ASSET__JExowoG1__"